import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { canManageCrmAccess, hasCrmPermission } from '@crm/permissions';
import { SettingsAccessTab } from './settings/SettingsAccessTab';
import { SettingsHallsTab } from './settings/SettingsHallsTab';

const TABS = [
  { key: 'access', label: 'Доступы администраторов' },
  { key: 'halls', label: 'Залы' },
];

export function CrmSettingsPage() {
  const { branchId } = useParams();
  const { profile, branches } = useSelector((s) => s.crmAuth);
  const [active, setActive] = useState('access');
  const visibleTabs = useMemo(
    () =>
      TABS.filter((tab) => {
        if (tab.key === 'access') return canManageCrmAccess(profile);
        if (tab.key === 'halls') {
          return hasCrmPermission(profile, branches, branchId, 'settings.halls.view');
        }
        return false;
      }),
    [branchId, branches, profile],
  );

  useEffect(() => {
    if (visibleTabs.length > 0 && !visibleTabs.some((tab) => tab.key === active)) {
      setActive(visibleTabs[0].key);
    }
  }, [active, visibleTabs]);
  const activeIsVisible = visibleTabs.some((tab) => tab.key === active);

  return (
    <section className="crm-settings-page">
      <header className="page-header">
        <h1>Настройки</h1>
      </header>

      <div className="tabs">
        {visibleTabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={tab.key === active ? 'active' : ''}
            onClick={() => setActive(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {visibleTabs.length === 0 && (
        <div className="form-card form-card--wide crm-settings-page__placeholder">
          <p className="muted">Недостаточно прав для просмотра настроек.</p>
        </div>
      )}

      {activeIsVisible && active === 'access' && <SettingsAccessTab branchId={branchId} />}

      {activeIsVisible && active === 'halls' && <SettingsHallsTab branchId={branchId} />}
    </section>
  );
}
